export const PROMPT_SUGGESTIONS = [
  'Write a LinkedIn post about AI trends in 2025',
  'Draft a cold sales email for a SaaS product',
  'Generate 10 startup ideas in the health tech space',
  'Explain React Server Components with examples',
  'Create a content calendar for Instagram for 30 days',
  'Write a product description for a premium brand',
  'Summarise the key points of a meeting transcript',
  'List the pros and cons of launching a mobile app vs web app',
  'Write a Python script for data visualization',
  'How to optimize a Next.js application for SEO?',
  'Create a marketing strategy for a new e-commerce store',
  'Draft a terms of service agreement for a mobile app',
]
